import { TableContainer as MUITableContainer } from '@mui/material';
import { Props } from '../../models/Props.types';

export default function TableContainer(props: Props) {
    return <MUITableContainer>{props.children}</MUITableContainer>;
}
